<template>
    <div class="articleCard"
         v-if="article.contentSeq">
        <router-link :to="'/articlePage/' + article.contentSeq"
                     :data-ga="`${gaInfo}${article.contentSeq}(預覽圖)`">
            <div class="photo"
                 :style="{
                    'background-image':
                        'url(' +
                        previewImage(article.previewImage) +
                        ')',
                }" />
        </router-link>
        <div class="px-2 px-sm-3 pt-3 pb-3">
            <div class="pb-2 d-flex justify-content-between">
                <div class="contentCata" v-if="article.categories">
                    <!-- {{ article.categories.join('/ ') }} -->
                    <span v-if="article.categories.length>1">
                        {{ article.categories.join('/ ') }}
                    </span>
                    <span v-else>
                        {{ article.categories[0] }}
                    </span>
                </div>
                <div class="date">{{ article.onDate }}</div>
            </div>
            <router-link :to="'/articlePage/' + article.contentSeq"
                         :data-ga="`${gaInfo}${article.contentSeq}(標題)`">
                <p class="contentTitle mb-2 mb-md-1">
                    {{ article.contentTitle }}
                </p>
            </router-link>
            <p class="content"
               :class="{ line3: line3 }">
                {{ article.previewContent }}
            </p>
            <ShareButtonRow :articleSeq="article.contentSeq"
                            :articleId="article.contentId"
                            :gaData="`${gaInfo}${article.contentSeq}(標題)`"/>
        </div>
        <InOrder v-if="isShowOrderNum"
                 :index="index" />
    </div>
</template>

<script>
import ShareButtonRow from './ShareButtonRow.vue';
import InOrder from './InOrder';
export default {
    name: 'ArticleCard',
    components: { InOrder, ShareButtonRow },
    props: {
        article: {
            type: Object,
            require: true,
        },
        gaInfo: {
            type: String,
            default: '健康及保險知識+｜',
        },
        line3: {
            type: Boolean,
            default: false,
        },
        isShowOrderNum: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            require: true,
        },
    },
    methods: {
        // goToPage(link) {
        //     link && window.open(link);
        // },
    },
};
</script>
<style lang="scss" scoped>
.articleCard {
    border-radius: $radius;
    overflow: hidden;
    border: 1px solid $gray-300;
    position: relative;
    width: 100%;
    @include media-breakpoint-up(md) {
        width: 32%;
        margin-right: 2%;
        &:nth-child(3n) {
            margin-right: 0;
        }
    }
    .photo {
        background-position: center center;
        background-size: cover;
        border: 0;
        background-repeat: no-repeat;
        padding-bottom: 52.75%;
        margin: -1px;
        background-color: #eee;
    }
    .content {
        font-size: 0.9375rem;
        position: relative;
        line-height: 1.2;
        color: $gray-600;
        height: 2.2rem;
        margin-bottom: 0.75rem;
        @include ellipsis-multi(2);
    }
    .line3 {
        height: 3.3rem;
        @include ellipsis-multi(3);
    }
    .date {
        font-size: 0.875rem;
        color: $gray-400;
        font-weight: normal;
    }
    .contentCata {
        font-size: 15px;
        color: $deep-red;
        // color: $gray-500;
        @extend %ellipsis-single;
    }
    .contentTitle {
        font-size: 1.25rem;
        font-weight: 600;
        @extend %ellipsis-single;
        @include media-breakpoint-up(sm) {
            font-size: 1.5rem;
        }
        @include media-breakpoint-up(md) {
            font-size: 1.25rem;
            &:hover {
                color: $warning;
            }
        }
        @include media-breakpoint-up(lg) {
            font-size: 1.5rem;
        }
    }
}
.swiper-slide {
    width: 85%;
    @include media-breakpoint-up(sm) {
        width: 65%;
    }
}
</style>
